module.exports = __webpack_public_path__ + "static/media/menu_transactionDiscount_hoverActive.34d9fce4.svg";